import { Kiosk_Ad_Set_Status } from '@occc/graphql';
import { deletePaginationParams } from '@occc-app/hooks/usePaginationParams';

import { useQueryParam } from './use-query-param.hook';

import { AdSetStatusType } from '../features/ad-sets-list-page/components/ad-sets-filter-form';

const isValidAdSetStatus = (value: string | null): value is AdSetStatusType => {
  if (!value) return true; // Empty string is valid for "All Statuses"

  return (
    value === Kiosk_Ad_Set_Status.Archived ||
    value === Kiosk_Ad_Set_Status.Draft ||
    value === Kiosk_Ad_Set_Status.Published
  );
};

const STATUS_PARAM = 'status';

export const useStatusFilter = () => {
  return useQueryParam<AdSetStatusType>(
    (searchParams) => {
      const status = searchParams.get(STATUS_PARAM);
      return isValidAdSetStatus(status) ? status : '';
    },
    (value, searchParams) => {
      if (value) {
        searchParams.set(STATUS_PARAM, value);
      } else {
        searchParams.delete(STATUS_PARAM);
      }

      deletePaginationParams(searchParams);
    },
  );
};
